// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"oY-z","subtitle":"pY-z","wrapper":"qY-z","leftArrow":"rY-z","rightArrow":"sY-z"};